export default function isValidPassword(password: string): boolean {
	return Array.from(password).length >= 8;
}
